import { render, staticRenderFns } from "./OrderItemMediaUploadForm.vue?vue&type=template&id=11e88c36"
import script from "./OrderItemMediaUploadForm.vue?vue&type=script&lang=js"
export * from "./OrderItemMediaUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports